import { useContext, useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import ReactMap from "/src/components/common/MapViewer/React";
import ResponsiveContainer from "/src/components/common/ResponsiveContainer";

import Card from "/src/components/Search/Card";

import { AppContext } from "/src/components/context/App";

function Results({ results, page, onPage }) {

  const context = useContext(AppContext);

  const data = results?.data || [];

  const mapFeatures = data.map(item => {

    const mapFeatureProps = context?.GET_SEARCH_RESULT_MAP_FEATURE_PROPS?.({ data: item });
    const cardProps = context?.GET_SEARCH_RESULT_CARD_PROPS?.({ data: item, search_type: context?.search_type });

    const searchResultCard = context?.GET_SEARCH_RESULT_CARD?.({ search_type: context.search_type, data: item });

    item.coordinates = typeof item.coordinates === "string" ? item.coordinates : "";
    const [lat, lng] = item.coordinates.split(',');

    if (lat > 0 && lng > 0) {
      return {
        id: item.id,
        iconUrl: item.featured_media_url__thumbnail,
        iconSize: [30, 30],
        position: [lat, lng],
        ...mapFeatureProps,
        popup: (
          <div style={{ width: 250 }}>
            {searchResultCard ? <div onClick={cardProps?.onClick} dangerouslySetInnerHTML={{ __html: searchResultCard }} /> : <Card data={item} {...cardProps} />}
          </div>
        )
      }
    }

  }).filter(item => item);

  const markers = mapFeatures.filter(item => item.type === "marker");
  const polygons = mapFeatures.filter(item => item.type === "polygon");

  // return (
  //   <div style={{ height: 500, width: 500 }}>
  //     <ReactMap markers={[]} />
  //   </div>
  // )
  return (
    <ResponsiveContainer className="search-results">
      <ReactMap markers={markers} polygons={polygons} />
    </ResponsiveContainer>
  );

}

export default Results;
